import { Validators } from '@angular/forms';

// Used to prevent from malicious CSV injection (same as backend)
export const validateUserName = Validators.pattern(/^(((\p{L}|[0-9]){1,}) ?((\p{L}|[0-9]){1,})){1,}$/u);
